import React from 'react';
import Select from './ui/Select';
import { NATURE_OF_BUSINESS, OEM_ODM, SUPPLIER_SUBCATEGORY } from '../utils/classification';

/**
 * What a supplier is: nature of business, OEM/ODM and sub-category. One component, so Invite Vendor,
 * the plant's Supplier Request form and the approval of that request ask the same three questions
 * the same way. `value` and `onChange(field, code)` use the API's field names; the caller lays the
 * two rows out (they are returned side by side as siblings).
 */
const SupplierClassificationFields = ({ value = {}, onChange, errors = {}, disabled = false, idPrefix = 'classification' }) => (
  <>
    <Select
      label="Nature of Business"
      placeholder="Choose the nature of business"
      options={NATURE_OF_BUSINESS}
      value={value.nature_of_business || ''}
      onChange={(code) => onChange('nature_of_business', code)}
      disabled={disabled}
      required
      error={errors.nature_of_business}
      id={`${idPrefix}-nature-of-business`}
    />
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <Select
        label="Supplier Type"
        placeholder="OEM or ODM"
        options={OEM_ODM}
        value={value.oem_odm || ''}
        onChange={(code) => onChange('oem_odm', code)}
        disabled={disabled}
        required
        error={errors.oem_odm}
        id={`${idPrefix}-oem-odm`}
      />
      <Select
        label="Supplier Sub-category"
        placeholder="Choose a sub-category"
        options={SUPPLIER_SUBCATEGORY}
        value={value.supplier_subcategory || ''}
        onChange={(code) => onChange('supplier_subcategory', code)}
        disabled={disabled}
        required
        error={errors.supplier_subcategory}
        id={`${idPrefix}-subcategory`}
      />
    </div>
  </>
);

export default SupplierClassificationFields;
